function backdrop () {
    const $existingBackdrop = document.querySelector('.search-bar-backdrop')

    if ($existingBackdrop) {
        $existingBackdrop.remove()
    }

    const $backdrop = document.createElement('div')
    $backdrop.classList.add('search-bar-backdrop')
    $backdrop.addEventListener('click', () => {
        document.body.classList.remove('search-bar-open')
        const $backdrop = document.querySelector('.search-bar-backdrop')

        if ($backdrop) {
            $backdrop.remove()
        }
        document.querySelector('.search-bar').classList.remove('open')
    })

    return $backdrop
}

export function SearchBar () {
    const $searchBar = document.querySelector('.search-bar')
    const $openButton = document.querySelector('.open-button-search-bar')
    const $searchInput = $searchBar?.querySelector('#search-field')
    const $clearTextButton = $searchBar?.querySelector('button.clear-text')

    $clearTextButton?.addEventListener('click', () => {
        $searchInput.setAttribute('value', '')
        $searchInput.value = ''
        $searchInput.focus()
    })

    $openButton?.addEventListener('click', () => {
        const $backdrop = backdrop()

        if (!document.body.classList.contains('search-bar-open')) {
            document.body.appendChild($backdrop)
        }

        document.body.classList.toggle('search-bar-open')
        document.querySelector('.search-bar').classList.toggle('open')
    })
}
